// Birim varyantı DR7 — önizlemede üç birim durumu etiketi (iç sihirbaz + portal aynı bileşen):
// çevrildi (açık mavi bilgi), uyumsuz (amber, satır yazılmaz), karşılaştırılamadı (gri, değer
// olduğu gibi). ≥14 px (DR11); ≤720 px'te metin 2 satıra sarılır (nowrap yok).

import type { CSSProperties } from "react";
import { formatKpiNumber } from "@mahir/shared";
import type { KpiPlannedCell } from "../../../api/kpi-import";
import { KPI_IMPORT_COPY } from "../../../lib/kpi-import-copy";
import { factorText } from "../../../lib/kpi-import-wizard";

const U = KPI_IMPORT_COPY.unit;

const base: CSSProperties = {
  display: "inline-block",
  maxWidth: "100%",
  minWidth: 140,
  padding: "2px 8px",
  borderRadius: 8,
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: 1.35,
  whiteSpace: "normal",
  textAlign: "left",
};

/** Otomatik çevrildi — "10 GJ → 2,78 MWh · ×0,2778" (açık mavi bilgi). */
export function ConvertedLabel({
  cell,
}: {
  cell: Pick<KpiPlannedCell, "converted" | "numericValue">;
}): JSX.Element | null {
  const c = cell.converted;
  if (!c) return null;
  return (
    <div
      data-testid="kpi-import-unit-converted"
      title={KPI_IMPORT_COPY.preview.convertedTag}
      style={{
        ...base,
        background: "color-mix(in srgb, var(--color-primary) 10%, white)",
        color: "var(--color-primary)",
      }}
    >
      {U.converted(
        `${formatKpiNumber(c.original)} ${c.fromUnit}`,
        `${formatKpiNumber(cell.numericValue ?? 0)} ${c.toUnit}`,
        factorText(c.factor),
      )}
    </div>
  );
}

/** Birim uyumsuz — amber; satır yazılmaz. */
export function IncompatibleLabel({ file, target }: { file: string; target: string }): JSX.Element {
  return (
    <div
      data-testid="kpi-import-unit-incompatible"
      style={{
        ...base,
        background: "var(--color-warning-bg)",
        color: "var(--color-warning-text)",
        border: "1px solid var(--color-warning-border)",
      }}
    >
      <b>{U.incompatible}</b>
      <div>{U.incompatibleDetail(file, target)}</div>
    </div>
  );
}

/** Birim karşılaştırılamadı — gri; değer olduğu gibi aktarılır. */
export function UnknownUnitLabel({
  note,
}: {
  note: { file: string; target: string };
}): JSX.Element {
  return (
    <div
      data-testid="kpi-import-unit-unknown"
      title={U.unknownTag}
      style={{
        ...base,
        background: "var(--color-surface-alt, #f1f3f5)",
        color: "var(--color-text-2)",
      }}
    >
      {U.unknown(note.file, note.target)}
    </div>
  );
}
